import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { OFFICE_INTRO_SAMPLE } from "../consts";
import { OfficeSceneProps } from "../types";

/** Korak "Mailovi": adrese e-pošte poslovnice s opisom i novi upit koji stiže na primarnu. */
const OfficeEmailScene: React.FC<OfficeSceneProps> = ({ name }) => {
  const primaryEmail = OFFICE_INTRO_SAMPLE.emails.find((email) => email.primary);

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Mailovi</div>
          <div className="text-sm font-bold text-slate-800 truncate">{name}</div>
          <div className="mt-3 space-y-2">
            {OFFICE_INTRO_SAMPLE.emails.map((email) => (
              <div key={email.address} className="rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-semibold text-slate-700 truncate">{email.address}</span>
                  {email.primary && (
                    <span className="px-1.5 py-0.5 rounded-full text-[0.55rem] font-semibold bg-blue-100 text-blue-700">
                      Primarna
                    </span>
                  )}
                </div>
                <div className="text-[0.6rem] text-slate-400 truncate">{email.description}</div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-blue-600 motion-safe:animate-pulse" />
            <span className="text-xs font-bold text-slate-800">Novi upit</span>
          </div>
          <div className="mt-1 text-[0.65rem] text-slate-400 truncate">Za: {primaryEmail?.address}</div>
          <div className="mt-3 space-y-1.5">
            <span className="block h-1.5 w-full rounded-full bg-slate-100" />
            <span className="block h-1.5 w-4/5 rounded-full bg-slate-100" />
            <span className="block h-1.5 w-3/5 rounded-full bg-slate-100" />
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Primarna adresa"
          subtitle="Prva za kontakt s poslovnicom"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M4 4h16v16H4zM4 6l8 7 8-7" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(OfficeEmailScene);
